import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { TxnService } from 'app/services/txn.service';
import * as StackTrace from 'stacktrace-js';
import { ShareService } from '../../../services';
import { AxthenticationService } from '../../../services/axthentication.service';
import { LogService } from './log.service';


@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private injector: Injector) { }

    handleError(error) {
        console.log('GlobalErrorHandler.....', error);
        const logService = this.injector.get(LogService);
        const location = this.injector.get(LocationStrategy);
        let router = this.injector.get(Router);
        let axthenticationService: AxthenticationService = this.injector.get(AxthenticationService);
        let txnService: TxnService = this.injector.get(TxnService);
        let shareService: ShareService = this.injector.get(ShareService);
        // this.axthenticationService.currentMenuId

        const message = error.message ? error.message : error.toString();
        const url = location instanceof PathLocationStrategy ? location.path() : '';
        // get the stack trace, lets grab the last 10 stacks only
        StackTrace.fromError(error).then(stackframes => {
            const stackString = stackframes
                .splice(0, 20)
                .map(function (sf) {
                    return sf.toString();
                }).join('\n');
            // log on the server
            console.error({ message, url, stack: stackString });

            let errorMsg: string = message + '\n' + stackString;
            console.log('****** webErrorMsg ****** ' + errorMsg);

            txnService.doErrorLog(errorMsg);
        });

        console.log('error end.');
        // throw error;
        if (axthenticationService.isLoggedIn) {
            router.navigate(['/main', { outlets: { mainContent: ['pagecode', 'error'] } }])
        } else {
            router.navigateByUrl('error');
        }
    }

}
